module.exports = __webpack_public_path__ + "media/images/topics/topics-heading-bg-inc-916ae8a906fdee1beebbb05789ee5d08.png";